import React, { ReactNode } from "react"
import { Flex } from "@chakra-ui/react"

type Props = {
  /** One block with shared borders, like Chakra's `ButtonGroup isAttached` */
  isAttached?: boolean
  children: ReactNode
}

const attachedStyles = {
  "&& > *": { borderRadius: 0 },
  "&& > *:first-of-type": { borderTopRadius: "md" },
  "&& > *:last-of-type": { borderBottomRadius: "md" },
  "&& > *:not(:first-of-type)": { mt: "-1px" },
}

const RadioCardGroup = ({ isAttached, children }: Props) => (
  <Flex direction="column" gap={isAttached ? 0 : 2.5} sx={isAttached ? attachedStyles : undefined}>
    {children}
  </Flex>
)

export default RadioCardGroup
